import React, { useRef } from "react";
import { Col, Container, FloatingLabel, Form, Row } from "react-bootstrap";
import {
  useSendPasswordResetEmail,
  useSignInWithEmailAndPassword,
} from "react-firebase-hooks/auth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import auth from "../../../firebase.init";
import Loading from "../../Shared/Loading/Loading";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SocialLogin from "../SocialLogin/SocialLogin";
import Header from "../../Shared/Header/Header";

const Login = () => {
  const emailRef = useRef("");
  let errorElement;
  const navigate = useNavigate();
  const location = useLocation();

  const [signInWithEmailAndPassword, user, loading, error] =
    useSignInWithEmailAndPassword(auth);

  const [sendPasswordResetEmail] = useSendPasswordResetEmail(auth);

  if (loading) {
    return <Loading></Loading>;
  }

  let from = location.state?.from?.pathname || "/";

  if (user) {
    navigate(from, { replace: true });
  }

  if (error) {
    errorElement = <p className="text-danger">Error: {error?.message}</p>;
  }

  const navigateRegister = () => {
    navigate("/register");
  };

  const handleLogin = (event) => {
    event.preventDefault();
    const email = event.target.email.value;
    const password = event.target.password.value;
    signInWithEmailAndPassword(email, password);
    console.log(email, password);
  };

  const resetPassword = async () => {
    const email = emailRef.current.value;
    if (email) {
      await sendPasswordResetEmail(email);
      toast("Sent email");
    } else {
      toast("Please enter your email address");
    }
  };

  return (
    <div>
      <Header></Header>
      <Container>
        <Row className="justify-content-md-center">
          <Col
            xs="12"
            lg="5"
            className="mt-3 mx-auto shadow-lg rounded-top px-5"
            style={{ color: "#000fff", fontWeight: "400", fontSize: "1.2rem" }}
          >
            <h2 style={{ color: "#CCD6F6" }} className="text-center my-3">
              Please Login
            </h2>
            <Form onSubmit={handleLogin} className="mb-3">
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <FloatingLabel label="Email address">
                  <Form.Control
                    style={{
                      backgroundColor: "transparent",
                      color: "#CCD6F6",
                    }}
                    type="email"
                    ref={emailRef}
                    name="email"
                    placeholder="Enter email"
                    required
                  />
                </FloatingLabel>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <FloatingLabel label="Password">
                  <Form.Control
                    style={{
                      backgroundColor: "transparent",
                      color: "#CCD6F6",
                    }}
                    type="password"
                    name="password"
                    placeholder="Password"
                    required
                  />
                </FloatingLabel>
              </Form.Group>
              <button type="submit" className="w-100 mt-4 btn-All">
                Login
              </button>
            </Form>
            {errorElement}
            <p style={{ color: "#CCD6F6" }}>
              New to Mosheur Rahman?{" "}
              <Link
                to="/register"
                className="text-primary text-decoration-none"
                onClick={navigateRegister}
              >
                Please Register
              </Link>
            </p>
            <p style={{ color: "#CCD6F6" }}>
              Forget Password?{" "}
              <span
                style={{ cursor: "pointer" }}
                className="text-primary"
                onClick={resetPassword}
              >
                Reset Password
              </span>
            </p>
            <ToastContainer />
          </Col>
          <SocialLogin></SocialLogin>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
